import { HttpService } from "./http.service";

const basePath = "/UserPreference";
const request = HttpService.handleRequest();

export const UserPreferenceService = {
  getAll,
  insert,
  update,
  insertOrUpdate,
  ByUserId
};

async function getAll() {
  return request.get(basePath);
}

async function insertOrUpdate(data) {
  return request.post(`${basePath}/create`, data);
}

async function insert(data) {
  return request.post(`${basePath}`, data);
}

async function update(data) {
  return request.put(basePath, data);
}

async function ByUserId(userId) {
  return request.get(`${basePath}/ByUserId/${userId}`);
}


export default UserPreferenceService;